var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-simple-table',{staticClass:"simpleTable",class:{ 'simpleTable--withHover': _vm.withHover },attrs:{"fixed-header":_vm.fixedHeader,"dense":_vm.dense}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }